export const arePasskeysSupported = () => {
  if (window.PublicKeyCredential) {
    return true;
  } else {
    return false;
  }
};